/*
 * @Description 组件 实时报警
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- index-sub-item start -->
	<div class="index-sub-item sub-item-alarms">
		<div class="sub-items-box-top"></div>
		<!-- sub-alarms-box -->
		<div class="sub-items-box-center sub-alarms-box">
			<div class="index-sub-title" >实时报警</div>
			<!-- sub-alarms-content start -->
			<div class="subAlarmsContent sub-alarms-content" v-resize="elPageResize">
				<!-- :style="{'max-height': (122 * dataList.length - 32) + 'px'}" -->
				
				<el-carousel v-if="contentOverFlag" height="122px" direction="vertical" :autoplay="true" arrow="always" indicator-position="" @change="carouselItemChange" style="overflow: visible;">
					<el-carousel-item v-for="(itm, i) in dataList" :key="i" :style="{overflow: (i == currIndex ? 'visible' : 'hidden')}">
						
						<!-- sub-alarms-item start -->
						<div class="sub-alarms-item" v-if="index >= i" v-for="(item, index) in dataList" :key="index" v-show="i == currIndex || i == lastIndex" >
							<!-- alarm-item-box start -->
							<div :class="{'alarm-item-box': true, 'alarm': item.num > 0, 'cursor-pointer': item.num > 0}" @click="handleItemBtn(item)" :title="spliceTitle(item)">
								<i class="item-alarm-icon"></i>
								<i class="right-arrow-icon"></i>
								<span class="alarm-item-type">{{item.label}}</span>
								<span class="alarm-item-num text-over">{{item.num}}</span>
							</div>
							<!-- alarm-item-box end -->
						</div>
						<!-- sub-alarms-item end -->
						
						<!-- sub-alarms-item start -->
						<div class="sub-alarms-item" v-if="index < i" v-for="(item, index) in dataList" :key="index" v-show="i == currIndex || i == lastIndex" >
							<!-- alarm-item-box start -->
							<div :class="{'alarm-item-box': true, 'alarm': item.num > 0, 'cursor-pointer': item.num > 0}" @click="handleItemBtn(item)" :title="spliceTitle(item)">
								<i class="item-alarm-icon"></i>
								<i class="right-arrow-icon"></i>
								<span class="alarm-item-type">{{item.label}}</span>
								<span class="alarm-item-num text-over">{{item.num}}</span>
							</div>
							<!-- alarm-item-box end -->
						</div>
						<!-- sub-alarms-item end -->
						
					</el-carousel-item>
				</el-carousel>
				
				<template v-else >
					<!-- sub-alarms-item start -->
					<div class="sub-alarms-item" v-for="(item, index) in dataList" :key="index" >
						<!-- alarm-item-box start -->
						<div :class="{'alarm-item-box': true, 'alarm': item.num > 0, 'cursor-pointer': item.num > 0}" @click="handleItemBtn(item)" :title="spliceTitle(item)">
							<i class="item-alarm-icon"></i>
							<i class="right-arrow-icon"></i>
							<span class="alarm-item-type">{{item.label}}</span>
							<span class="alarm-item-num text-over">{{item.num}}</span>
						</div>
						<!-- alarm-item-box end -->
					</div>
					<!-- sub-alarms-item end -->
				</template>
				
			</div>
			<!-- sub-alarms-content end -->
		</div>
		<!-- sub-alarms-box -->
		<div class="sub-items-box-bottom"></div>
	</div>
	<!-- index-sub-item end -->
</template>

/* JS */
<script>
	// API 类型
	import ApiType from '@/request/api-type';
	// API 报警
	import ApiAlarm from '@/request/api-alarm';
	// API oam
	import ApiOam from '@/request/api-oam';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "IndAlarm",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 数据列表
				dataList: [
					{code: 2, key: 'invadeAlarm', label: '入界报警', num: 0},
					{code: 3, key: 'outAlarm', label: '出界报警', num: 0},
					{code: 1, key: 'sosAlarm', label: '紧急求助', num: 0},
					{code: 4, key: 'disappearAlarm', label: '消失报警', num: 0},
					{code: 7, key: 'lowPowerAlarm', label: '低电报警', num: 0},
					{code: 8, key: 'fallingAlarm', label: '高空坠落', num: 0},
					{code: 9, key: 'collapseAlarm', label: '塌方砸倒', num: 0},
					//{code: 5, label: '区域入界报警', num: 4},
					//{code: 6, label: '带离报警', num: 6},
				],
				// 报警类型 keys
				alarms: [],
				// 报警 list
				alarmList: [],
				// 报警数量
				alarmNums: {},
				// flag 文本溢出
				contentOverFlag: false,
				
				// 定时器
				timer_checkDataInt: null,// 检索数据
				
				// 轮播 index current
				currIndex: 0,
				// 轮播 index last
				lastIndex: 0,
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 开启订阅消息
			this.startSubscribes();
			
			// 数据查询
			this.searchData();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 取消订阅消息
			this.endSubscribes();
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des 监听条件查询表单尺寸
			 * @Auth
			 * @Date
			 */
			elPageResize(data) {
				let height;
				
				// 空值
				if (this.$checkEmpty(data) || this.$checkEmpty(data.height)) {
					height = document.querySelector(".subAlarmsContent").offsetHeight;
				} else {
					height = data.height.replace(/px/g, '');
				}
				
				height = Math.ceil(height);
				
				// flag 文本溢出
				this.contentOverFlag = (122 * this.dataList.length - 32) > height;
            },
            
			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date
			 */
			startSubscribes() {
				// 订阅消息 详情页
				this.sub_dataChange = this.$pubsub.subscribe('AlarmChange', (name, data) => {
					// 数据查询
					this.searchData();
				});
			},
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date
			 */
			endSubscribes() {
				//取消订阅 详情页
				this.$pubsub.unsubscribe(this.sub_dataChange);
			},
			
			//========================== 订阅消息 end ==========================
			
			/**
			 * @Des 点击条目btn
			 * @Auth
			 * @Date
			 */
			handleItemBtn(row) {
				// 空值 中止
				if (this.$checkEmpty(row) || !(row.num > 0)) {
					return false;
				}
				
				// 点击更多或点击条目报警大于0
				
				// 路由 跳转
				this.$router.replace({path: ('/manager/alarm/real'), query: {alarm: row.code}}, ()=>{}, ()=>{});
				
				return false;
				// 参数
				let filter = {};
				
				// 空值
				if (this.$checkEmpty(row)) {
					// 点击 更多
					
					// alarmFlag 出口
					let alarmFlag = false;
					let dataList = Object.assign([], this.dataList);
					// 遍历
					dataList.forEach((data, index) => {
						// 有出口 中止
						if (alarmFlag) return false;
						if (data.num > 0) {
							alarmFlag = true;
						}
					});
					filter.activeName = alarmFlag ? 'real' : 'history';
				} else {
					// 点击 条目
					
					// current code
					filter.onAlarmType = row.code;
					// activeName
					filter.activeName = 'real';
				}
				
				// 点击条目
				this.handleDetailBtn('Alarm', '各类报警', filter);
			},
			
			/**
			 * @Des 点击条目
			 * @Auth
			 * @Date
			 */
			handleDetailBtn(detailSubRef, detailSubName, detailFilters) {
				// 发布消息 详情页
				this.$pubsub.publish('handleDetail', {showDetailFlag: true, detailSubRef: detailSubRef, detailSubName: detailSubName, detailFilters: detailFilters});
			},
			
			/**
			 * @Des title 拼接
			 * @Auth
			 * @Date
			 */
			spliceTitle(row) {
				let title = row.label + '：' + row.num;
				if (row.num > 0) {
					title += '\n（点击查看详情）';
				}
				return title;
			},
			
			//========================== 数据查询 start ==========================
			/**
			 * @Des 数据查询
			 * @Auth 
			 * @Date 
			 */
			searchData(){
				// 数据查询 报警类型
				this.searchAlarmStatus();
			},// searchData
			
			/**
			 * @Des 数据查询 报警类型
			 * @Auth 
			 * @Date 
			 */
			searchAlarmStatus() {
				this.$request.postJsonRequest(ApiType.findTypeApi, {
					projectId: this.$store.state.currentProjectId,
					type: "alarmTypes"
				}).then(result => {
					if(result.code == 0 && result.data.alarmTypes){
						// 数据列表
						this.dataList = Object.assign([], []);
						
						// 报警类型 keys
						let alarms = [];
						
						let alarmStatus = Object.assign([], result.data.alarmTypes);
						alarmStatus.forEach((row, index) => {
							// 报警数量
							let num = this.alarmNums[row.state] > 0 ? this.alarmNums[row.state] : 0;
							// 数据列表
							this.dataList.push({code: row.state,label: row.name,num: num});
							// 报警类型 keys
							alarms.push(row.state);
						});
						// 报警类型 keys
						this.alarms = Object.assign([], alarms);
						
						// 数据查询 报警list
						this.searchAlarm();
					}
				}).catch(error => {
					console.error('查询报警类型异常', ApiType.findTypeApi, error);
				})
			},// searchAlarmStatus
			/**
			 * @Des 数据查询 报警list
			 * @Auth 
			 * @Date 
			 */
			searchAlarm() {
				this.$request.postJsonRequest(ApiOam.Search_Alarm_Uri, {
					projectId: this.$store.state.currentProjectId,
                    dealState: [1],// 0 预警	1 报警	2 已处理
					alarms: this.alarms,// 报警类型 keys
                    orderBy: {
                        alarm_date: 'desc'
                    },
                    total: 0,
                    startNum: 0,
                    limit: 0
				}).then(result => {
					// 数据列表
					//this.dataList[index].num = result.total > 0 ? result.total : 0;
					
					let alarmNums = {};
					// 报警 list
					this.alarmList = !this.$checkEmpty(result.rows) ? Object.assign([], result.rows) : [];
					// 遍历 报警数据list
					this.alarmList.forEach((row, index) => {
						let alarmType = row.alarm;
						// 报警数量
						alarmNums[alarmType] = (alarmNums[alarmType] > 0 ? alarmNums[alarmType] : 0) + 1;
					});
					
					// 报警数量
					this.alarmNums = Object.assign({}, alarmNums);
					// 数据列表
					this.dataList.forEach((row, index) => {
						row.num = alarmNums[row.code] > 0 ? alarmNums[row.code] : 0;
					});
					
					// 排序
					this.dataList.sort((a, b) => {
						return b.num - a.num;
					});
					
					// 监听条件查询表单尺寸
					this.elPageResize();
					
				}).catch(error => {
					console.error('查询报警数据异常', ApiOam.Search_Alarm_Uri, error);
				})
			},// searchAlarm
			//========================== 数据查询 end ==========================
			
			/**
			 * @Des 轮播切换
			 * @Auth 
			 * @Date 
			 */
			carouselItemChange(currIndex, lastIndex) {
				// 轮播 index
				this.carouselIndex = currIndex;
				// 轮播 index current
				this.currIndex = currIndex;
				// 轮播 index last
				this.lastIndex = lastIndex;
			},
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/IndexItems/IndAlarm.vue